import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import CurrencyLedger from "../components/CurrencyLedger";

export default function LedgerPopout() {
  const { app, accountId } = useParams();
  const { token, loading } = useApp();
  if (loading) return <div className="grid min-h-screen place-items-center opacity-60">Loading…</div>;
  if (!token) return <Navigate to="/login" replace />;
  return (
    <div className="min-h-screen bg-white p-4 dark:bg-[#0b1020]" data-testid="ledger-popout-page">
      <div className="w-full">
        <h1 className="mb-3 font-head text-lg">Transaction register</h1>
        <CurrencyLedger app={app} accountId={accountId} popout />
      </div>
    </div>
  );
}
